import React, { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import { useRouter } from 'next/router';
import { supabase_public } from '../../lib/supabaseClient';


const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { data, error } = await supabase_public.auth.resetPasswordForEmail(email,
            { redirectTo: process.env.NEXT_PUBLIC_FRONTEND_URL + 'accounts/update-password',
              } );
        console.log( process.env.NEXT_PUBLIC_FRONTEND_URL + 'accounts/update-password')

        if (data) {
            setMsg("Check your email for the password reset link. If it hasn't appeared try checking spam.")
        }
        if (error) {
            alert("Error in sending password reset link.")
        }
    };

    // useEffect(() => {
    //     const supabaseListener = supabase.auth.onAuthStateChange(async (event, session) => {
    //         if (event === "PASSWORD_RECOVERY") {
    //             const newPassword = prompt("What would you like your new password to be?");
    //             const { data, error } = await supabase.auth.updateUser({ password: newPassword });

    //             if (data) alert("Password updated successfully!");
    //             if (error) alert("There was an error updating your password.");
    //         }
    //     });

    // }, []);

    return (
        <div className='bg-grad-background bg-no-repeat bg-cover bg-center font-gilroy-regular'>
        <div className="h-screen w-screen flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
                <h2 className="text-2xl font-bold mb-6 text-gray-700">Forgot Password</h2>

                <form onSubmit={handleSubmit} className='mb-4'>
                    <div className="mb-5">
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-600">
                            Email
                        </label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter your email"
                            required
                            value={email}
                            onChange={handleEmailChange}
                            className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:focus:ring-offset-gray-900 font-gilroy-regular"
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full p-2 bg-indigo-700 text-white rounded-md hover:bg-indigo-600 font-gilroy-regular"
                    >
                        Reset Password
                    </button>
                </form>
                 <span className='text-sm font-medium text-gray-600'> {msg} </span>
            </div>
        </div>
        </div>
    );
};

export default ForgotPassword;
